import React from 'react';
import close from "../../../assets/Icons/close.png";
import light from "../../../assets/invalidImage/light.png";
import invalid_image from "../../../assets/invalidImage/invalid-image.png";
import "../signal.css";

const InvalidImageError = ({ onClose, onRetake, onViewReference }) => {
    return (
        <div className="h-full bg bg-transparent w-full flex justify-center items-center">
            <div className="bg-white w-11/12 max-w-md flex flex-col items-center p-6 rounded-lg shadow-xl">
                <div className="flex justify-between w-full mb-4">
                    <p className="text-red-600 text-2xl font-semibold">Error</p>
                    <button type="button" onClick={onClose}>
                        <img src={close} className="w-7 h-7" alt="close" />
                    </button>
                </div>
                <div className="text-base py-3 px-4 w-full">
                    <p className="font-medium my-1 text-signal-ai-blue">ပုံထွက်မှားနေပါသည်။ <br /> Aiမှန်ကန်စွာစစ်ဆေးနိုင်ရန်</p>
                    <p className="flex my-3 text-signal-ai-blue">
                        <img src={light} alt="light" className="w-5 h-5 me-3" />
                        <span>ကောင်းမွန်သောအလင်းရောင်တွင်ရိုက်ပါ</span>
                    </p>
                    <p className="flex my-3 text-signal-ai-blue">
                        <img src={invalid_image} alt="invalid" className="w-5 h-5 me-3" />
                        <span>ကြည်လင်ပြတ်သားသည့်ပုံဖြစ်ရပါမည်</span>
                    </p>
                </div>
                <div className="w-full space-y-3">
                    <button
                        type="button"
                        className="bg-white text-signal-ai-blue font-normal text-base w-full h-11 border border-signal-ai-blue rounded-lg"
                        onClick={onViewReference}
                    >
                        နမူနာကြည့်မည်
                    </button>
                    <button
                        type="button"
                        className="bg-signal-ai-secondary text-white w-full h-11 font-semibold text-base shadow-2xl rounded-lg"
                        onClick={onRetake}
                    >
                        ပြန်ရိုက်မည်
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InvalidImageError;
